import { createContext, useContext, useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { fetchSunData } from '../services/ioBroker'
import { fetchTodayEnergyStats } from '../services/influxdb'

const SolarContext = createContext(null)

export function useSolar() {
  return useContext(SolarContext)
}

export function SolarProvider({ children }) {
  const sunQ         = useQuery({ queryKey: ['sun'],         queryFn: fetchSunData,           refetchInterval: 60_000 })
  // Polling owned by DataContext; this subscribes to the cached value only.
  const todayEnergyQ = useQuery({ queryKey: ['todayEnergy'], queryFn: fetchTodayEnergyStats,  enabled: false })

  const value = useMemo(() => ({
    sunData:          sunQ.data ?? null,
    todayEnergyStats: todayEnergyQ.data ?? null,
  }), [sunQ.data, todayEnergyQ.data])

  return <SolarContext.Provider value={value}>{children}</SolarContext.Provider>
}
